import zh from "@/locales/zh-CN.json";
import zhTw from "@/locales/zh-TW.json";
import vi_VN from "@/locales/vi_VN.json";
import ja_JP from "@/locales/ja_JP.json";
import en from "@/locales/en.json";
import config from "../config/index";

// 同时兼容站点、浏览器和接口里会出现的多种 locale 写法，避免页面直接回显 i18n key。
const messageGroups = {
  zhTw,
  zh,
  vi_VN,
  ja_JP,
  en,
};

const messages = {};

function assignLocaleAliases(localeKeys, messageKey) {
  localeKeys.forEach((localeKey) => {
    messages[localeKey] = messageGroups[messageKey];
  });
}

assignLocaleAliases(
  [
    "zh",
    "tw",
    "zh-CN",
    "zh_CN",
    "zh-Hans",
    "zh_Hans",
    "zh-Hans-CN",
    "zh_Hans_CN",
    "zh-TW",
    "zh_TW",
    "zh-Hant",
    "zh_Hant",
    "zh-HK",
    "zh_HK",
    "zh-MO",
    "zh_MO",
    "hans",
    "hant",
  ],
  "zhTw"
);

assignLocaleAliases(["en", "en-US", "en_US", "en-GB", "en_GB"], "en");
assignLocaleAliases(["vi", "vi-VN", "vi_VN"], "vi_VN");
assignLocaleAliases(["ja", "ja-JP", "ja_JP"], "ja_JP");

export { messages };

export default defineI18nConfig(() => ({
  legacy: false,
  locale: config.defaultLocale,
  fallbackLocale: config.defaultLocale,
  messages,
}));
